import { useNavState } from '@/common/navState/NavStateContext';
import { useEffect, useState } from 'react';

// Provides state (just like useState) that will also sync with navState, so that it can be preserved on page refresh
export const useNavStateSync = (navStateKey, initialValue) => {
  const { navState, assign } = useNavState();
  const [state, setState] = useState(navState[navStateKey] ?? initialValue);
  useEffect(() => assign(navStateKey, state), [state]);
  return [state, setState];
};
